<template>
    <ContentLoader v-slot :loading="item == null" class="h-screen-header">
        <div class="flex flex-col h-screen-header">
            <div ref="heroContainer" class="flex-none rounded-xl transition-all duration-300 ease-out"
                 :class="{'hero-minimized': isHeroMinimized}">
                <Hero :image="item.image" :is-minimized="isHeroMinimized">
                <!-- 普通状态的内容 -->
                <div v-show="!isHeroMinimized" class="flex flex-col justify-between md:h-56"
                     style="transition: opacity 0.2s ease-out">
                    <div class="ml-4 flex flex-col justify-start items-start z-10">
                        <div class="flex items-center ml-1">
                            <div class="text-4xl font-medium text-clip overflow-hidden h-10">{{ item.name }}</div>
                            <button class="btn btn-active btn-sm ml-2" @click.stop="addFavouriteArtist">
                                <svg xmlns="http://www.w3.org/2000/svg" :class="['h-6', 'w-6', isFavourite ? 'fill-current' : '']" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" /></svg>
                            </button>
                        </div>
                        <div class="flex flex-col my-2 text-gray-600">
                            <span>{{ item.albumCount }}张专辑 · {{ item.trackCount }} 首歌曲</span>
                        </div>
                        <div v-if="item.description" class="mb-3 text-gray-600 text-ellipsis overflow-hidden h-24 cursor-pointer"
                             onclick="my_modal_2.showModal()">
                            {{ item.description }}
                        </div>
                        <div v-if="item.genres.length > 0">
                            <div class="badge badge-neutral" v-for="(genre, index) in item.genres" :key="genre">
                                <span v-if="index > 0">•</span>
                                <router-link :to="{ name: 'genre', params: { id: genre } }">
                                    {{ genre }}
                                </router-link>
                            </div>
                        </div>
                    </div>
                    <div class="ml-4 z-10 flex">
                        <button class="btn btn-neutral btn-active btn-sm" @click="playNow">
                            Play
                        </button>
                    <div class="drawer drawer-end w-16 ml-2" v-if="isSuperuser">
                        <input id="my-drawer-4" type="checkbox" class="drawer-toggle" v-model="isEditArtist" />
                        <div class="drawer-content">
                            <!-- Page content here -->
                            <label for="my-drawer-4" class="btn btn-neutral btn-active btn-sm" @click="handleEditArtist">EDIT</label>
                        </div>
                        <div class="drawer-side">
                            <label for="my-drawer-4" aria-label="close sidebar" class="drawer-overlay"></label>
                            <div class="p-4 w-80 min-h-full bg-base-200 text-base-content">
                                <div class="font-medium text-xl mb-4">编辑艺术家信息</div>

                                <div class="mb-1">艺术家:</div>
                                <div>
                                    <input type="text"
                                        v-model="artistFormData.name"
                                        class="input input-bordered input-sm w-full max-w-xs" />
                                </div>
                                <div class="mb-1 mt-1">艺术家封面:</div>
                                <div>
                                    <!-- 图片上传 -->
                                    <div class="relative">
                                        <!-- 图片预览区域 -->
                                        <div
                                            class="border-2 border-dashed border-gray-300 rounded-lg p-2 text-center hover:border-gray-400 transition-colors">
                                            <div v-if="artistImagePreview" class="relative inline-block">
                                                <img :src="artistImagePreview" alt="艺术家封面"
                                                    class="max-w-full max-h-48 rounded-lg shadow-md">
                                                <button @click.stop="removeArtistImage"
                                                    class="absolute -top-2 -right-2 btn btn-circle btn-xs btn-error text-white hover:bg-red-600 z-50"
                                                    type="button" style="pointer-events: auto;">
                                                    ✕
                                                </button>
                                                <!-- 替换图片按钮 -->
                                                <button @click.stop="triggerArtistImageReplacement"
                                                    class="absolute -bottom-2 -right-2 btn btn-circle btn-xs btn-neutral text-white z-50"
                                                    type="button" style="pointer-events: auto;" title="替换图片">
                                                    +
                                                </button>
                                            </div>
                                            <div v-else>
                                                <svg class="mx-auto h-12 w-12 text-gray-400" stroke="currentColor"
                                                    fill="none" viewBox="0 0 48 48">
                                                    <path
                                                        d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                                                        stroke-width="2" stroke-linecap="round"
                                                        stroke-linejoin="round" />
                                                </svg>
                                                <p class="mt-2 text-sm text-gray-500">点击上传或拖拽图片到此处</p>
                                                <p class="text-xs text-gray-400">支持 JPG, PNG, GIF (最大 5MB)</p>
                                            </div>

                                            <!-- 隐藏的文件输入 -->
                                            <input ref="artistImageInput" type="file" accept="image/*"
                                                @change="handleArtistImageChange"
                                                class="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10"
                                                :disabled="isUploadingArtistImage" v-show="!artistImagePreview">
                                            <!-- 上传进度 -->
                                            <div v-if="isUploadingArtistImage"
                                                class="absolute inset-0 bg-white bg-opacity-75 flex items-center justify-center rounded-lg">
                                                <div class="text-center">
                                                    <span class="loading loading-spinner loading-md"></span>
                                                    <p class="mt-2 text-sm text-gray-600">上传中...</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="mb-1 mt-1">描述:</div>
                                <textarea class="textarea textarea-bordered textarea-xs w-full max-w-xs h-48" placeholder="." v-model="artistFormData.description"></textarea>
                                <button class="btn btn-neutral btn-sm btn-wide" @click="handleSave">保存</button>
                                <button class="btn btn-primary btn-sm btn-wide mt-2" @click="handleSaveMetadata">保存并更新音乐元数据</button>
                                <div class="mt-4">封面推荐:</div>
                                <div v-for="(item2, index) in artistsData" :key="index">
                                    <div class="flex justify-center items-center mt-1 mb-2">
                                        <div>
                                            <img :src="item2.artist_img"
                                            class="mask mask-squircle w-16 h-16 cursor-pointer object-contain"
                                            @click="handleCopy('artist_img', item2.artist_img)">
                                        </div>
                                        <div class="flex-1 ml-2">
                                            <div class="cursor-pointer hover:underline"
                                                @click="handleCopy('name', item2.artist)">{{item2.artist}}</div>
                                            <div class="truncate w-56 text-gray-400 cursor-pointer hover:underline"
                                                @click="handleCopy('description', item2.desc)">{{item2.desc}}</div>
                                        </div>
                                    </div>
                                    <hr>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button class="btn btn-neutral btn-active btn-sm" onclick="artist_delete.showModal()" v-if="isSuperuser">
                        DELETE
                    </button>
                    </div>
                </div>

                <!-- 缩小状态的内容 -->
                <div v-show="isHeroMinimized" class="flex items-center justify-between w-full py-2 px-1"
                     style="transition: opacity 0.2s ease-out">
                    <div class="flex flex-col">
                        <div class="text-lg font-medium truncate max-w-[200px]">{{ item.name }}</div>
                        <div class="text-sm text-gray-600 dark:text-gray-300 truncate max-w-[200px]">{{ item.albumCount }}张专辑 · {{ item.trackCount }}首歌曲</div>
                    </div>
                    <div class="flex items-center space-x-2">
                        <button class="btn btn-active btn-xs" @click.stop="addFavouriteArtist">
                            <svg xmlns="http://www.w3.org/2000/svg" :class="['h-4', 'w-4', isFavourite ? 'fill-current' : '']" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                            </svg>
                        </button>
                        <button class="btn btn-neutral btn-xs" @click="playNow">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4" fill="currentColor" viewBox="0 0 24 24">
                                <path d="M8 5v14l11-7z"/>
                            </svg>
                        </button>
                    </div>
                </div>
            </Hero>
        </div>
        <div ref="trackContainer" class="flex-1 mt-2 overflow-y-auto rounded-xl" @scroll="handleScroll">
            <template v-if="item.topTracks.length > 0">
                <div class="flex justify-between mt-5 mb-2 cursor-pointer">
                    <h3 class="my-0 ml-2">
                        热门歌曲
                    </h3>
                    <div class="mr-2 cursor-pointer link" @click="viewAll(item)">
                        查看全部
                    </div>
                </div>
                <TrackList :tracks="item.topTracks.slice(0, 5)" no-artist />
            </template>

            <template v-if="item.albums.length > 0">
                <h3 class="mt-5 mb-1">
                    最新专辑
                </h3>
                <AlbumList :items="item.albums.slice(0, 12)" small />
            </template>

            <template v-if="item.similarArtist.length > 0">
                <h3 class="mt-5 mb-1">
                    相似艺术家
                </h3>
                <ArtistList :items="item.similarArtist" />
            </template>
        </div>
        </div>
        <!-- Open the modal using ID.showModal() method -->
        <dialog id="my_modal_2" class="modal">
            <div class="modal-box">
                <h3 class="text-lg font-bold">艺术家简介:{{item.name}}</h3>
                <div class="py-4">
                    <textarea class="textarea textarea-bordered textarea-xs w-full h-96" placeholder="." v-model="item.description"></textarea>
                </div>
            </div>
            <form method="dialog" class="modal-backdrop">
                <button>close</button>
            </form>
        </dialog>
        <dialog id="artist_delete" class="modal modal-bottom sm:modal-middle">
            <div class="modal-box">
                <h3 class="text-lg font-bold">删除艺术家</h3>
                <p class="py-4">从音乐收藏中删除此艺术家，但不会删除源文件。</p>
                <div class="modal-action">
                    <form method="dialog">
                        <!-- if there is a button in form, it will close the modal -->
                        <button class="btn btn-neutral btn-sm mr-2" @click="handleDelete">确认</button>
                        <button class="btn btn-sm">取消</button>
                    </form>
                </div>
            </div>
        </dialog>
    </ContentLoader>
</template>
<script>
    import Hero from '../../../components/library/Hero'
    import AlbumList from '@/views/library/album/AlbumList.vue'
    import ArtistList from '@/views/library/artist/ArtistList.vue'
    import TrackList from '@/views/library/track/TrackList.vue'
    import ContentLoader from '@/components/library/ContentLoader'
    import {mapGetters} from 'vuex'

    export default {
        components: {
            Hero,
            ContentLoader,
            AlbumList,
            ArtistList,
            TrackList
        },
        data() {
            return {
                item: null,
                id: this.$route.params.id,
                customSettings: {
                    isShow: false,
                    title: '艺术家详情'
                },
                artistsData: [],
                isFavourite: false,
                uploadHeader: [
                    {name: 'X-CSRFToken', value: this.getCookie('django_vue_cli_csrftoken')},
                    {name: 'AUTHORIZATION', value: this.getCookie('AUTHORIZATION')}
                ],
                uploadUrl: '/apimt/upload_image/',
                artistFormData: {},
                reloadImg: false,
                isEditArtist: false,
                // 新增的图片上传相关数据
                artistImagePreview: null,
                isUploadingArtistImage: false,
                // 滑动动画相关数据
                isHeroMinimized: false,
                scrollThreshold: 50, // 滑动阈值，增加到50px避免过早触发
                scrollHysteresis: 20, // 防抖区间（滞后值），增加到20px
                isMobile: false,
                scrollAnimationFrame: null,
                lastScrollTop: 0 // 记录上次滚动位置
            }
        },
        watch: {
            id: {
                immediate: true,
                async handler(value) {
                    this.item = null
                    this.item = await this.$api.subsonic.getArtistDetails(value)
                    this.isFavourite = this.item.favourite
                }
            }
        },
        computed: {
            ...mapGetters({
                isSuperuser: 'getIsSuperuser'
            }),
        },
        mounted() {
            this.checkMobile()
            window.addEventListener('resize', this.checkMobile)
        },
        beforeDestroy() {
            window.removeEventListener('resize', this.checkMobile)
            if (this.scrollAnimationFrame) {
                cancelAnimationFrame(this.scrollAnimationFrame)
            }
        },
        methods: {
            playNow() {
                return this.$store.dispatch('playTrackList', {
                    tracks: this.item.topTracks
                })
            },
            shuffleNow() {
                return this.$store.dispatch('player/shuffleNow', {
                    tracks: this.item.topTracks
                })
            },
            toggleFavourite() {
                return this.favouriteStore.toggle('artist', this.id)
            },
            handleEditArtist() {
                if (this.item.image) {
                    // 设置图片预览
                    this.artistImagePreview = this.item.image
                }
                this.artistFormData = {
                    name: this.item.name,
                    description: this.item.description,
                    artist_img: this.item.image
                }
                this.$api.Task.fetchArtists({
                    title: this.item.name,
                    resource: 'kuwo',
                    full_path: ''
                }).then((res) => {
                    this.artistsData = res.data
                })
            },
            handleSave() {
                this.$api.Task.postArtist({
                    id: this.id,
                    artist_img: this.artistFormData.artist_img,
                    description: this.artistFormData.description,
                    name: this.artistFormData.name
                }).then((res) => {
                    if (res.result) {
                        this.customSettings.isShow = false
                        this.$myMsg.notify({
                            title: '修改成功！',
                            type: 'success',
                            time: 2000,
                        })
                        this.$api.subsonic.getArtistDetails(this.id).then((res) => {
                            this.item = res
                        })
                    } else {
                        this.$myMsg.notify({
                            title: '修改失败！',
                            type: 'error',
                            time: 2000,
                        })
                    }
                })
            },
            handleSaveMetadata(){
                this.$api.Task.postArtist({
                    id: this.id,
                    artist_img: this.artistFormData.artist_img,
                    description: this.artistFormData.description,
                    name: this.artistFormData.name,
                    write_metadata: true
                }).then((res) => {
                    if (res.result) {
                        this.customSettings.isShow = false
                        this.$myMsg.notify({
                            title: '修改成功！',
                            type: 'success',
                            time: 2000,
                        })
                        this.$api.subsonic.getArtistDetails(this.id).then((res) => {
                            this.item = res
                        })
                        this.isEditArtist = false
                    } else {
                        this.$myMsg.notify({
                            title: '修改失败！',
                            type: 'error',
                            time: 2000,
                        })
                    }
                })
            },
            handleDelete() {
                this.$api.Task.deleteArtist({ 'id': this.id }).then((res) => {
                    if (res.result) {
                        this.$myMsg.notify({
                            title: '删除成功！',
                            type: 'success',
                            time: 2000,
                        })
                        this.$router.push({path: '/artists/most-albums'})
                    } else {
                       this.$myMsg.notify({
                            title: '删除失败！',
                            type: 'error',
                            time: 2000,
                        })
                    }
                })
            },
            addFavouriteArtist() {
                if (this.isFavourite) {
                    this.$api.subsonic.removeFavourite(this.item.id, 'artist').then((res) => {
                        this.isFavourite = false
                    })
                } else {
                    this.$api.subsonic.addFavourite(this.item.id, 'artist').then((res) => {
                        this.isFavourite = true
                    })
                }
            },
            // 渲染图片
            handleRes(response) {
                if (response.result) {
                    this.artistFormData.artist_img = response.data
                    return true
                } else {
                    return false
                }
            },
            // 移除艺术家封面
            removeArtistImage() {
                this.artistImagePreview = null
                this.artistFormData.artist_img = ''
                if (this.$refs.artistImageInput) {
                    this.$refs.artistImageInput.value = ''
                }
            },
            // 触发艺术家封面替换
            triggerArtistImageReplacement() {
                // 直接创建临时input，更可靠
                this.createTempFileInput('artist')
            },
            
            // 创建临时文件输入
            createTempFileInput(type) {
                const input = document.createElement('input')
                input.type = 'file'
                input.accept = 'image/*'
                input.style.display = 'none'
                input.onchange = (event) => {
                    if (type === 'artist') {
                        this.handleArtistImageChange(event)
                    }
                    // 清理临时元素
                    if (input.parentNode) {
                        input.parentNode.removeChild(input)
                    }
                }
                document.body.appendChild(input)
                input.click()
            },
            // 处理艺术家封面图片选择
            handleArtistImageChange(event) {
                const file = event.target.files[0]
                if (!file) return
                
                // 验证文件类型
                if (!file.type.startsWith('image/')) {
                    this.$myMsg.notify({
                        title: '文件类型错误',
                        content: '请选择图片文件',
                        type: 'error',
                        time: 2000,
                    })
                    return
                }
                
                // 验证文件大小 (5MB)
                if (file.size > 5 * 1024 * 1024) {
                    this.$myMsg.notify({
                        title: '文件过大',
                        content: '图片大小不能超过5MB',
                        type: 'error',
                        time: 2000,
                    })
                    return
                }
                
                // 显示预览
                const reader = new FileReader()
                reader.onload = (e) => {
                    this.artistImagePreview = e.target.result
                }
                reader.readAsDataURL(file)
                
                // 上传图片
                this.uploadImage(file, 'artist')
            },
            // 通用图片上传方法
            uploadImage(file, type) {
                const formData = new FormData()
                formData.append('upload_file', file)
                
                // 设置上传状态
                if (type === 'artist') {
                    this.isUploadingArtistImage = true
                }
                
                // 创建 XMLHttpRequest
                const xhr = new XMLHttpRequest()
                
                // 设置请求头
                xhr.open('POST', this.uploadUrl, true)
                xhr.setRequestHeader('X-CSRFToken', this.getCookie('django_vue_cli_csrftoken'))
                xhr.setRequestHeader('AUTHORIZATION', this.getCookie('AUTHORIZATION'))
                xhr.withCredentials = true
                
                // 处理响应
                xhr.onload = () => {
                    // 重置上传状态
                    if (type === 'artist') {
                        this.isUploadingArtistImage = false
                    }
                    
                    if (xhr.status === 200) {
                        try {
                            const response = JSON.parse(xhr.responseText)
                            if (this.handleRes(response)) {
                                this.$myMsg.notify({
                                    title: '上传成功',
                                    type: 'success',
                                    time: 2000,
                                })
                            } else {
                                this.$myMsg.notify({
                                    title: '上传失败',
                                    content: response.message || '未知错误',
                                    type: 'error',
                                    time: 2000,
                                })
                            }
                        } catch (e) {
                            console.log(e)
                            this.$myMsg.notify({
                                title: '上传失败',
                                content: '服务器响应格式错误',
                                type: 'error',
                                time: 2000,
                            })
                        }
                    } else {
                        this.$myMsg.notify({
                            title: '上传失败',
                            content: `HTTP错误: ${xhr.status}`,
                            type: 'error',
                            time: 2000,
                        })
                    }
                }
                
                // 处理错误
                xhr.onerror = () => {
                    if (type === 'artist') {
                        this.isUploadingArtistImage = false
                    }
                    this.$myMsg.notify({
                        title: '上传失败',
                        content: '网络错误',
                        type: 'error',
                        time: 2000,
                    })
                }
                
                // 发送请求
                xhr.send(formData)
            },
            handleCopy(k, v) {
                if (k === 'artist_img') {
                    this.files1 = [
                        {
                            name: 'cover.png',
                            status: 'done',
                            url: v
                        }
                    ]
                    this.artistFormData.artist_img = v
                    // 设置图片预览
                    this.artistImagePreview = v
                } else {
                    this.artistFormData[k] = v
                }
            },
            viewAll(item) {
                this.$router.push({path: `/artist/tracks/${item.id}`, query: {name: item.name}})
            },
            // 处理滑动事件 (使用 requestAnimationFrame 优化性能，添加滞后防抖)
            handleScroll(event) {
                if (this.scrollAnimationFrame) {
                    cancelAnimationFrame(this.scrollAnimationFrame)
                }

                this.scrollAnimationFrame = requestAnimationFrame(() => {
                    const scrollTop = event.target.scrollTop
                    const scrollDirection = scrollTop > this.lastScrollTop ? 'down' : 'up'
                    this.lastScrollTop = scrollTop

                    // 使用更大的滞后区间防止闪烁
                    // 向下滚动：超过阈值+滞后值才缩小
                    // 向上滚动：低于阈值-滞后值才恢复
                    if (!this.isHeroMinimized && scrollTop > this.scrollThreshold + this.scrollHysteresis) {
                        this.isHeroMinimized = true
                    } else if (this.isHeroMinimized && scrollTop < this.scrollThreshold - this.scrollHysteresis) {
                        this.isHeroMinimized = false
                    }
                    // 在临界区间内不做任何改变，保持当前状态
                })
            },
            // 检查是否为移动端
            checkMobile() {
                this.isMobile = window.innerWidth < 768 // md断点
            }
        }
    }
</script>

<style scoped>
/* 移动端艺术家封面缩小动画 */
.hero-minimized {
    transform: none;
    height: auto !important;
    min-height: auto !important;
}

/* Hero容器的平滑过渡 */
.rounded-xl {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    will-change: transform, height;
}

/* 防止内容切换时的闪烁 */
.hero-minimized > * {
    transition: opacity 0.2s ease-out;
}

/* 缩小状态的特殊样式 */
@media (max-width: 767px) {
    .hero-minimized {
        margin-bottom: 0.5rem;
    }
}

@media (min-width: 768px) {
    .hero-minimized {
        transform: none;
    }
}
</style>
